/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class PrintRepository extends repositories.BaseRepository {

    constructor() 
    {
        super({
            creation: new models.ProductPrint({ id: "" }), // id empty so it's not created in db 
            zoom : new models.Zoom(),
        });

        // TODO : to remove
        fx.set("printmodel", this);
    }

    get print()
    {
        return this.creation;
    }


    initData(data)
    {
        super.initData(data);

        this.creation.init(data.creation, {"CreationElement" : "ProductPrintPage"});

        this.creation.creationOption = data.creationOption;
    }

});
